import { PortalProductConfig, getProductWithVariants, ProductWithVariants } from '../../models/product';
import { auslandsKvDamageReportSteps } from 'app/products/travel/config/damage-report-steps';
import { SingleInsurantWidgetComponent } from '../../customer-portal/widgets/single-insurant-widget/single-insurant-widget.component';
import { defaultContractWidgets } from '../../config/default-contract-widgets';

// NOTE: this is identical to the Schutzbrief Students in all but name!

const portalConfig: PortalProductConfig = {
    damageReportSteps: auslandsKvDamageReportSteps,
    icon: 'backpacker',
    widgets: [...defaultContractWidgets, { component: SingleInsurantWidgetComponent }],
};

export const travelInsuranceForPupils: ProductWithVariants = getProductWithVariants({
    slug: 'schueler-auslandskrankenversicherung',
    title: 'Schüler-Auslandskrankenversicherung',
    fullTitle: 'Auslandskrankenversicherung für Auslandsaufenthalte zur schulischen und universitären Weiterbildung',
    collapsableTitle:
        'Auslands&shy;kranken&shy;versicherung für Auslandsaufenthalte zur schulischen und universitären Weiterbildung',
    insuranceTypeName: 'Schutzbrief Students',
    insuranceTypeId: 13,
    portalConfig,
    legacy: true,
});
